export enum ApiRoute {
  PAYPAL_ACCEPT_PAYMENT = '/payments/paypal/acceptPayment',
  PAYPAL_CREATE_ORDER = '/payments/paypal/createOrder',
}
